(function () {



  var IDS_TO_TOGGLE = [
    "shopify-section-template--24819818398030__rich_text_figmfi",
    "shopify-section-template--24819818398030__1768385268a85188de"
  ];

  function setHidden(hidden) {
    document.querySelectorAll(".reviews-io-polaris-widget").forEach(function (el) {
      el.style.display = hidden ? "none" : "";
    });

    IDS_TO_TOGGLE.forEach(function (id) {
      var el = document.getElementById(id);
      if (el) el.style.display = hidden ? "none" : "";
    });
  }

  function checkReviews() {
    var hasReviews = document.querySelector(".item__review") !== null;

    if (hasReviews) {
      setHidden(false);
    } else {
      setHidden(true);
    }
  }

  function init() {
    // Default: nichts verstecken
    setHidden(false);

    // Erst prüfen
    checkReviews();

    // Falls Reviews async geladen werden → beobachten
    var observer = new MutationObserver(function () {
      checkReviews();
    });

    observer.observe(document.body, { childList: true, subtree: true });

    // Nach 8 Sekunden stoppen (Performance)
    setTimeout(function () {
      observer.disconnect();
    }, 8000);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

})();